import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/index.vue";
import store from "@/store";
import { storage } from "@/utils";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        meta: {
          needLogin: false,
          active: "home",
          title: "PCCM专培师资"
        }
      },
      {
        path: "/exam",
        name: "Exam",
        component: () =>
          import(/* webpackChunkName: "Exam" */ "../views/Exam/index.vue"),
        meta: {
          needLogin: true,
          active: "exam"
        }
      },
      {
        path: "/exam/list",
        name: "ExamList",
        component: () =>
          import(
            /* webpackChunkName: "ExamList" */ "../views/ExamList/index.vue"
          ),
        meta: {
          needLogin: true,
          active: "exam"
        }
      },
      {
        path: "/train",
        name: "Train",
        component: () =>
          import(/* webpackChunkName: "Train" */ "../views/Train/index.vue"),
        meta: {
          needLogin: false,
          active: "train"
        }
      },
      {
        path: "/video",
        name: "Video",
        component: () =>
          import(/* webpackChunkName: "Video" */ "../views/Video/index.vue"),
        meta: {
          needLogin: true
        }
      }
    ]
  }
];

const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  let token = storage.get("token") || "";
  if (token) {
    const { has_fetch } = store.state.user;
    if (!has_fetch) {
      store.dispatch("user/userInfo").then((res) => {
        console.log(res, "res");
        next();
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
